import React from 'react';
import classNames from 'classnames';
import styles from './M39AnchorMenu.module.scss';

export interface M39AnchorMenuProps {
	anchors: Array<{
		anchor?: string;
		menuTitle?: string;
	}>;
	activeId?: string;
	navigationLabel?: string;
	navRef?: React.Ref<HTMLElement>;
}

export const M39AnchorMenu: React.FC<M39AnchorMenuProps> = ({ anchors, activeId, navigationLabel, navRef }) => {
	if (!anchors || anchors.length === 0) return null;

	return (
		<nav ref={navRef} className={styles.M39AnchorMenu} aria-label={navigationLabel}>
			<ul className={styles.M39AnchorMenu_list}>
				{anchors.map((item, index) => {
					return (
						<li
							key={index}
							className={classNames(styles.M39AnchorMenu_linkItem, {
								[styles.M39AnchorMenu_linkItem___active]: activeId === item.anchor,
							})}
						>
							<a
								className={styles.M39AnchorMenu_link}
								href={`#${item.anchor || ''}`}
								title={item.menuTitle ? `Go to ${item.menuTitle}` : undefined}
								aria-label={item.menuTitle ? `Go to ${item.menuTitle}` : undefined}
								aria-current={activeId === item.anchor ? 'location' : undefined}
							>
								{item.menuTitle}
							</a>
						</li>
					);
				})}
			</ul>
		</nav>
	);
};
